export const FORBIDDEN_EXCEPTION = 403;

export const SUPPORTED_LANGS = ['en', 'es', 'fr', 'it', 'nl', 'pt-BR', 'pt-PT', 'ru', 'uk', 'zh-CN', 'ar'];

export const EN = 'en';

export const RTL = 'rtl';

export const LTR = 'ltr';
